// Genre pairs that cancel each other in Suno's pattern space
export const GENRE_CONFLICT_MATRIX: [string, string][] = [
  // Extreme metal vs soft/delicate genres
  ['death metal', 'bossa nova'],
  ['death metal', 'smooth jazz'],
  ['death metal', 'lounge'],
  ['death metal', 'lullaby'],
  ['death metal', 'children'],
  ['black metal', 'gospel'],
  ['black metal', 'bossa nova'],
  ['black metal', 'lounge'],
  ['black metal', 'disco'],
  ['grindcore', 'ambient'],
  ['grindcore', 'new age'],
  ['grindcore', 'quiet storm'],
  ['doom metal', 'bubblegum pop'],
  ['doom metal', 'children'],
  ['doom metal', 'disco'],
  ['thrash metal', 'lullaby'],
  ['sludge metal', 'dream pop'],
  // Punk/aggressive vs refined/classical
  ['punk', 'barbershop'],
  ['punk', 'baroque'],
  ['hardcore', 'quiet storm'],
  ['hardcore', 'bossa nova'],
  ['noise rock', 'smooth jazz'],
  ['industrial', 'acoustic folk'],
  ['industrial', 'bluegrass'],
  // Electronic vs traditional/acoustic
  ['dubstep', 'acoustic folk'],
  ['dubstep', 'bluegrass'],
  ['trap', 'baroque'],
  ['trap', 'classical'],
  ['techno', 'bluegrass'],
  ['drum and bass', 'barbershop'],
  // Hip hop vs historical
  ['hip hop', 'medieval'],
  ['hip hop', 'baroque'],
  ['reggaeton', 'bluegrass'],
  ['g-funk', 'celtic'],
  // Tempo-implied conflicts
  ['ballad', 'breakneck'],
  ['ballad', 'thrash'],
  ['slow burn', 'frantic'],
  ['ambient', 'mosh pit'],
  ['downtempo', 'blast beat'],
  ['lullaby', 'aggressive'],
  // Mood contradictions in genre space
  ['choral', 'industrial'],
  ['gospel', 'black metal'],
  ['worship', 'satanic'],
];

// Vocal instruction pairs that contradict each other
export const VOCAL_CONFLICT_PAIRS: [string, string][] = [
  ['whispered', 'belted'],
  ['whisper', 'belt'],
  ['breathy', 'powerful projection'],
  ['soft falsetto', 'screaming'],
  ['hushed', 'aggressive shout'],
  ['intimate whisper', 'full volume'],
  ['gentle', 'harsh vocals'],
  ['sweet', 'growling'],
  ['choir', 'solo voice only'],
  ['unison', 'call and response'],
  ['spoken word', 'melisma'],
  ['monotone', 'dramatic range'],
  ['deadpan', 'emotional'],
  ['restrained', 'unleashed'],
  ['murmured', 'screamed'],
  ['lullaby vocal', 'death growl'],
  ['crooning', 'shrieking'],
  ['talk-sing', 'operatic'],
];
